import { BemMethod, createBem } from '@om-fe/utils';
import { MarketType } from '@om-fe/models';

export const ADVANTAGE_SYMBOL: string = 'A';
export const DEFAULT_DISPLAYED_NUMBER_OF_MATCHES = 10;
export const DEFAULT_MARKET_SELECTOR_NUMBER = 20;
export const MAIN_MARKET_MIN_LIMIT = 1;
export const MAIN_MARKET_MEDIUM_LIMIT = 2;
export const MAIN_MARKET_MAX_LIMIT = 3;
export const UNDER_STRING_CONSTANT = 'under'; // the value 'under' is hardcoded but confirmed that will always be like that for an over/under market
export const OVER_STRING_CONSTANT = 'over'; // the value 'over' is hardcoded but confirmed that will always be like that for an over/under market

export enum EVENT_INFO {
    SERVE_ID = '37',
    POSSESSION_ID = '40',
    NUMBER_OF_EVENT_PARTS = '51',
    MATCH_TIME_ID = '95',
    REMAINING_TIME_ID = '96',
    CURRENT_EVENT_PART_ID = '92',
    SCORE_ID = '1',
    RED_CARDS = '4',
}

export const MATCH_LIST_BEM: BemMethod = createBem({
    name: 'MatchList',
});

export const MARKET_BEM: BemMethod = createBem({
    name: 'MarketSelector'
});

export const OM_DROPDOWN_BEM: BemMethod = createBem({
    name: 'OM-Dropdown'
});

export const MARKET_SELECTOR_BEM: BemMethod = createBem({
    name: 'MarketSelectorContent'
});

export enum MatchListItemLayout {
    Normal = 'normal',
    V2 = 'v2',
    Special = 'special',
    VirtualSport = 'VirtualSport',
}

// Add here those markets that need to have a param displayed on the odds button
export const marketsIdsToDisplayOddsParamFor = [
    MarketType.AsianHandicap,
    MarketType.GameHandicap,
    MarketType.SetHandicap,
    MarketType.PointsHandicap,
    MarketType.HomeDrawAwayWithHandicap,
    MarketType.CornerAsianHandicap,
    MarketType.MapsHandicap,
    MarketType.CornerHandicap,
    MarketType.GameHandicapWithDraw,
    MarketType.AsianHandicapWithScore,
    MarketType.MostKillsHandicap,
    MarketType.FragsHandicap,
    MarketType.RoundHandicap,
];

// Add here those markets that will need to display a param in between the odds
export const marketsIdsToDisplayOddsParamBetweenOdds = [
    MarketType.OverUnder,
    MarketType.SetsOverUnder,
    MarketType.MapsOverUnder,
    MarketType.PointsOverUnder,
    MarketType.CornersOverUnder,
    MarketType.BaronsSlainOverUnder,
    MarketType.BookingPointsOverUnder,
    MarketType.BoundariesOverUnder,
    MarketType.CardsOverUnder,
    MarketType.CenturiesOverUnder,
    MarketType.CheckoutOverUnder,
    MarketType.DragonsSlainOverUnder,
    MarketType.DropGoalsOverUnder,
    MarketType.FieldGoalsOverUnder,
    MarketType.FoulsOverUnder,
    MarketType.HitsOverUnder,
    MarketType.InhibitorsDestroyedOverUnder,
    MarketType.KillsScoredOverUnder,
    MarketType.PointsWonOverUnder,
    MarketType.RoshansSlainOverUnder,
    MarketType.ShotsOnTargetOverUnder,
    MarketType.TowersDestroyedOverUnder,
    MarketType.TriesOverUnder,
    MarketType.WidesOverUnder,
    MarketType.GoalsOverUnder,
    MarketType.RemainingTimeOverUnder,
    MarketType.CrushingBlowsOverUnder,
    MarketType.MaxComboDamageOverUnder,
    MarketType.TimeElapsedOverUnder,
    MarketType.TotalDemolitionsOverUnder,
    MarketType.CorrectRoundPayedOverUnder,
    MarketType.StrikesHitOverUnder,
    MarketType.StrikesAttemptsOverUnder,
    MarketType.RoundsOverUnder,
];

export const DEFAULT_GROUPS_EXPANDED = Infinity;
export const MATCH_LIST_GROUP_BY: string = 'parentId';
export const MATCH_LIST_GROUP_BY_COUNTRY: string = 'venueId';
export const MATCH_LIST_GROUP_BY_CATEGORY: string = 'categoryId';
export const DEFAULT_LIVE_SIDEBAR_ODDS_EXPANDED = 0;
export const DEFAULT_LIVE_SIDEBAR_GROUPS_EXPANDED = 0;
export const DEFAULT_LIVE_SIDEBAR_EVENT_NUMBER = 20;
